import ProgressBar from 'react-bootstrap/ProgressBar';
import { NotebookFile } from './hooks/useGetAllFiles';
import { useUploadProgress } from './hooks/uploadProgressStore';

type FileReadinessProgressProps = {
  file: NotebookFile;
};

function isTempFileId(id: string) {
  return id.startsWith('temp-');
}

/** Dual readiness bars: upload → viewable, then RAG → Pratus AI. */
export function FileReadinessProgress({ file }: FileReadinessProgressProps) {
  const uploadPercent = useUploadProgress(file.id);
  const isUploading = isTempFileId(file.id) || !file.fileUrl;
  const isAiPending = !!file.fileUrl && file.rag_ready !== true;

  if (!isUploading && !isAiPending) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-1" style={{ minWidth: '8rem' }}>
      {isUploading && (
        <div>
          <div className="d-flex justify-content-between txt--xs text-muted mb-1">
            <span>Available to view</span>
            <span>{Math.round(uploadPercent ?? 0)}%</span>
          </div>
          <ProgressBar
            now={uploadPercent ?? 0}
            style={{ height: 6, backgroundColor: 'var(--neutral-400)' }}
            aria-label="Upload progress until file can be viewed"
          />
        </div>
      )}
      {!isUploading && isAiPending && (
        <div>
          <div className="txt--xs text-muted mb-1">Ready for Pratus AI</div>
          <ProgressBar
            animated
            now={100}
            style={{ height: 6, backgroundColor: 'var(--neutral-400)' }}
            aria-label="Indexing progress for Pratus AI"
          />
        </div>
      )}
    </div>
  );
}
